import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer"; // Импортируем футер
import Home from "./pages/Home";
import Equipment from "./pages/Equipment"; // Импортируем страницу Домофоны
import Contacts from "./pages/Сontacts";
import Tariffs from "./pages/Tariffs";
import Requisites from "./pages/Requisites";
import About from "./pages/About"; // Импортируем страницу О компании
import Careers from "./pages/Careers"; // Импортируем новую страницу
import News from "./pages/News"; // Импортируем новую страницу
import Login from "./pages/Login"; // Импортируем страницу Логина
import AdminPanel from "./pages/AdminPanel"; // Импортируем страницу Админки
import CookieConsent from "./components/CookieConsent"; // Исправлен импорт CookieConsent
import './App.css'; // Импортируем CSS

function App() {
  return (
    <Router>
      <div className="app-container">
        {/* Хедер будет отображаться на всех страницах */}
        <Header />
        
        {/* Основные маршруты приложения */}
        <main className="main-content">
          <Routes>
            {/* Главная страница */}
            <Route path="/" element={<Home />} />
            {/* Страница Домофоны */}
            <Route path="/equipment" element={<Equipment />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/tariffs" element={<Tariffs />} />
            <Route path="/requisites" element={<Requisites />} />
            {/* Страница О компании */}
            <Route path="/about" element={<About />} />
            {/* Страница Вакансии */}
            <Route path="/careers" element={<Careers />} />
            {/* Новая страница Новости */}
            <Route path="/news" element={<News />} />
            {/* Страница Логина */}
            <Route path="/login" element={<Login />} />
            {/* Админская панель */}
            <Route path="/admin/news" element={<AdminPanel />} />
          </Routes>
        </main>
        
        {/* Футер будет отображаться на всех страницах */}
        <Footer />
        
        {/* Компонент согласия на использование cookies */}
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;